/**
 * A conferência copied into a simulation, as the screens need it (#586).
 *
 * The enum mirrors `@rp/core`'s `simulation-copy.ts` by hand: the web app is
 * its own build and cannot import the server's packages. `simulationCopy.test.ts`
 * reads that file and fails when the two disagree.
 */
export enum SimulationCopyBasis {
  Recorded = 'recorded',
  CurrentErp = 'current_erp',
}

/** Where a simulation was copied from. `copiedFrom` on the conferência's detail. */
export interface CopiedFrom {
  /** Null once the original has been removed. */
  readonly verificationId: string | null
  readonly accountId: string
  readonly accountName: string
  readonly branchCode: number
  readonly quotationNumber: number
  readonly basis: SimulationCopyBasis
  /** When the ERP gave the answers the copy replays. */
  readonly answeredAt: string
  readonly copiedBy: string
  readonly copiedAt: string
}

/** What making a copy answers. */
export interface SimulationCopyMade {
  readonly verificationId: string
  /** The internal account, where the simulation is. */
  readonly accountId: string
  readonly basis: SimulationCopyBasis
  /** Listed receitas whose file could not be copied. */
  readonly missingAttachments: number
}

/** `50/302140`, the way a conferência is said. */
export function copiedFromLabel(from: Pick<CopiedFrom, 'branchCode' | 'quotationNumber'>): string {
  return `${from.branchCode}/${from.quotationNumber}`
}

/** What the copy replays, in one sentence, with when the ERP said it. */
export function copyBasisSentence(basis: SimulationCopyBasis, answeredAt: string): string {
  const when = new Date(answeredAt).toLocaleString('pt-BR')
  return basis === SimulationCopyBasis.Recorded
    ? `Analisada com as respostas que o ERP deu em ${when}, quando a original foi analisada.`
    : `Tirada do estado atual do ERP em ${when}: a original foi analisada antes de guardarmos as respostas do ERP, e a farmácia pode ter alterado o orçamento desde então.`
}
